import { ThemedText } from "@/components/themed-text";
import { BrandColors } from "@/constants/theme";
import { webSocketService } from "@/lib/services/websocket";
import { useAuthStore } from "@/stores/use-auth-store";
import { useBookingJobStore } from "@/stores/use-booking-job-store";
import Ionicons from "@react-native-vector-icons/ionicons";
import { useRouter } from "expo-router";
import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";

export function BackToHomeButton() {
  const router = useRouter();
  const clearStore = useBookingJobStore((state) => state.clearStore);
  const setActiveBooking = useAuthStore((state) => state.setActiveBooking);

  const handlePress = () => {
    clearStore();
    setActiveBooking(null);
    webSocketService.disconnect();
    router.replace("/(tabs)");
  };

  return (
    <TouchableOpacity style={styles.button} onPress={handlePress}>
      <ThemedText style={styles.text} type="defaultSemiBold">
        Back to Home
      </ThemedText>
      <Ionicons name="chevron-forward" size={20} color="#fff" />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    gap: 12,
    backgroundColor: BrandColors.success,
  },
  text: {
    fontSize: 16,
    color: "#fff",
    fontWeight: "600",
  },
});
